<template>
  <v-footer padless class="mt-8" color="transparent">
    <v-card class="flex elevation-0" flat tile color="transparent">
      
      <v-divider class="mx-10" style="border-color: #E0E5F2 !important;"></v-divider>

      <v-card-text class="py-6 text-center">
        <span style="color: #A3AED0; font-weight: 500;">
          &copy; {{ new Date().getFullYear() }} — 
        </span>
        <span class="live-fit-text">LIVE FIT</span>
        
        <div class="caption mt-1" style="color: #A3AED0; letter-spacing: 0.5px;">
          Sistema de Gestión Integral v1.0 | <span style="color: #4318FF; font-weight: bold;">Perú 🇵🇪</span>
        </div>
      </v-card-text>
      
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "PieComponent",
};
</script>

<style scoped>

.live-fit-text {
  color: #1B2559 !important; 
  font-weight: 800;         
  font-size: 1.1em;
  letter-spacing: 1.5px;      
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialogos/PieComponent.vue